var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCircleBlue3({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#0a5ec0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.737 11.362q0 1.405-.85 2.389-.852.984-2.39 1.354v.061q1.815.226 2.748 1.107.933.873.933 2.359 0 2.163-1.569 3.373-1.57 1.2-4.48 1.2-2.44 0-4.328-.81v-2.697q.871.44 1.918.718a8 8 0 0 0 2.071.277q1.569 0 2.317-.533.75-.534.749-1.713 0-1.056-.861-1.497-.862-.44-2.748-.44h-1.139v-2.43h1.16q1.742 0 2.542-.452.81-.461.81-1.569 0-1.702-2.133-1.702a5 5 0 0 0-1.507.246q-.759.246-1.692.851L10.822 9.27q2.05-1.476 4.89-1.477 2.329 0 3.672.944 1.353.943 1.353 2.625"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCircleBlue3);
export default __webpack_public_path__ + "static/media/icon-circle-blue-3.c102bc8f944a906cc39c843c0a0b71e3.svg";
export { ForwardRef as ReactComponent };